<template>
  <div>
    <Navbar />
  </div>
  <section class="section">
    <router-view/>
  </section>
</template>

<script>
import { useMainStore } from './store'
import Navbar from './components/layout/Navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar
  },
  beforeCreate() {
    const store = useMainStore()
    store.initializeStore()
  },
}

</script>
